export enum AttendanceSheetDayEnum {
  INDEFINIDO = 1,
  PRESENTE = 2,
  FALTA_JUSTIFICADA = 3,
  FALTA_NAO_JUSTIFICADA = 4,
  FERIADO = 5,
  FERIAS = 6,
  PENDENTE = 7,
  NAO_PREENCHIDO = 8
}

export function attendanceSheetDayEnumInFull(status: AttendanceSheetDayEnum): string {
  switch (status) {
    case AttendanceSheetDayEnum.PRESENTE:
      return 'Presente';
    case AttendanceSheetDayEnum.FALTA_JUSTIFICADA:
      return 'Falta Justificada';
    case AttendanceSheetDayEnum.FALTA_NAO_JUSTIFICADA:
      return 'Falta Não Justificada';
    case AttendanceSheetDayEnum.FERIADO:
      return 'Feriado';
    case AttendanceSheetDayEnum.FERIAS:
      return 'Recesso';
    case AttendanceSheetDayEnum.PENDENTE:
      return 'Pendente';
    default:
      return '-';
  }
};